"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withSimpleSubListDesign = exports.asSubList = void 0;

var core_1 = require("@bodiless/core");

var react_1 = __importStar(require("react"));

var lodash_1 = require("lodash");

var fclasses_1 = require("@bodiless/fclasses");

var withListButtons_1 = __importDefault(require("./withListButtons"));

var List_1 = __importDefault(require("./List"));

var asTitledItem = function asTitledItem(Item) {
  var TitledItem = function TitledItem(_a) {
    var children = _a.children,
        rest = __rest(_a, ["children"]); // prepare and pass the submenu title as a prop according to rc-menu <SubMenu /> specification
    // wrap the title with current node,
    // otherwise the title will read data from incorrect node when it is rendered by <SubMenu />


    var node = core_1.useNode().node;
    var children$ = react_1.default.createElement(core_1.NodeProvider, {
      node: node
    }, children);
    return react_1.default.createElement(Item, __assign({
      title: children$
    }, rest));
  };

  return TitledItem;
};

var startComponents = {
  WrapperItem: fclasses_1.asComponent('li'),
  List: fclasses_1.asComponent('ul'),
  Title: core_1.withOnlyProps('key', 'children')(react_1.Fragment)
};

var SubList$ = function SubList$(_a) {
  var title = _a.title,
      children = _a.children,
      components = _a.components,
      overview = _a.overview,
      rest = __rest(_a, ["title", "children", "components", "overview"]);

  var WrapperItem = components.WrapperItem,
      List = components.List,
      Title = components.Title;
  return react_1.default.createElement(WrapperItem, __assign({}, rest), react_1.default.createElement(Title, null, title), react_1.default.createElement(List, {
    overview: overview
  }, children));
};

var SubList = fclasses_1.designable(startComponents, 'SubList')(SubList$);
/**
 * Converts a component or tag to a "bodiless" list. The component itself (usually
 * a variant of 'ul' or 'ol') will be used as the wrapper for the list, and the data
 * will be taken from bodiless data.
 *
 * @param nodeKeys
 */

var asBodilessList = function asBodilessList(nodeKeys, // @TODO - Handle default data
// eslint-disable-next-line @typescript-eslint/no-unused-vars
defaultData, useOverrides) {
  return function (Component) {
    return lodash_1.flow(fclasses_1.replaceWith(List_1.default), withListButtons_1.default(useOverrides), fclasses_1.withDesign({
      Wrapper: fclasses_1.replaceWith(fclasses_1.asComponent(Component)),
      Item: fclasses_1.withoutProps(['addItem', 'deleteItem', 'canDelete'])
    }), core_1.withNodeKey(nodeKeys))(Component);
  };
}; // This ensures that the original item is used as the sublist wrapper item.


var asSubListWrapper = function asSubListWrapper(Component) {
  return fclasses_1.withDesign({
    WrapperItem: fclasses_1.replaceWith(Component)
  })(SubList);
};
/**
 * HOC which can be applied to a list item to convert it to a sublist.
 */


var asSubList = function asSubList(useOverrides) {
  return lodash_1.flow(asBodilessList('sublist', undefined, useOverrides), fclasses_1.withDesign({
    Wrapper: asSubListWrapper
  }), asTitledItem);
};

exports.asSubList = asSubList;

var withSimpleSubListDesign = function withSimpleSubListDesign(depth) {
  return function (withDesign$) {
    return depth === 0 ? lodash_1.identity : fclasses_1.withDesign({
      Item: lodash_1.flow(withDesign$, withSimpleSubListDesign(depth - 1)(withDesign$))
    });
  };
};

exports.withSimpleSubListDesign = withSimpleSubListDesign;
exports.default = asBodilessList;